<div class="loading-spinner" *ngIf="isLoading">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
